import React, { FC } from 'react';
import { useTranslation } from '@blocs.i18n';
import Button from '@minecraft.button';
import Icon from '@minecraft.icon';
import styled from 'styled-components';
import { CLAIM_ACCOUNT_STEP, ModalStepProps } from './types';

type Props = ModalStepProps;

const StyledButton = styled(Button)`
  text-decoration: none;
  padding-left: 0;
`;

const prevStep = {
  [CLAIM_ACCOUNT_STEP.LOGIN]: CLAIM_ACCOUNT_STEP.SELECT_COUNTRY,
  [CLAIM_ACCOUNT_STEP.FORGOT_PASSWORD]: CLAIM_ACCOUNT_STEP.LOGIN,
  [CLAIM_ACCOUNT_STEP.ACCOUNT_EMAIL_CONFIRM]: CLAIM_ACCOUNT_STEP.FORGOT_PASSWORD,
};

const ModalHeader: FC<Props> = ({ step, setStep }) => {
  const { t } = useTranslation();
  switch (step) {
    case CLAIM_ACCOUNT_STEP.SELECT_COUNTRY:
      return <>{t('common:claimAdditionalAccounts.title')}</>;
    case CLAIM_ACCOUNT_STEP.LOGIN:
    case CLAIM_ACCOUNT_STEP.FORGOT_PASSWORD:
    case CLAIM_ACCOUNT_STEP.ACCOUNT_EMAIL_CONFIRM:
      return (
        <StyledButton color="link" onClick={() => setStep(prevStep[step])}>
          <Icon name="back-2" /> {t('common:button.goBack')}
        </StyledButton>
      );
    default:
      return null;
  }
};

export default ModalHeader;
